// import { TotalData } from '@/views/aiAdvisorDiagnosis/index.type';
import { convertChartToImageApi } from '@/api/chart';
import { WECOM_CORP_ID } from '@/config/env';
import { times100, extractNumber } from '@/lib/utils';
import Decimal from 'decimal.js';
import { calculateAdjustment } from '@/views/aiAdvisorDiagnosis/components/tabs/RecommendationsTab/utils';
import { actionBarTabType } from '@/types';
import { type TotalCopilotValue } from '@/stores/types/copilotValue';
import { type CopilotValue2Detail } from '@/stores/types/copilotDeatail/copilot2Detail';
import { toPng, toBlob } from 'html-to-image';
import { toast } from 'sonner';
// 数据格式化配置
export interface FormatConfig {
  selectedMetrics: Record<string, boolean>;
  totalData: Partial<TotalCopilotValue>;
  tabType?: actionBarTabType;
  fundData?: any;
  timeRange?: string;
}

// 格式化后的数据项
export interface FormattedDataItem {
  type: 'text' | 'image';
  content: string;
  imageId?: string;
  title: string;
}

export const generateExportContent = async (
  blobElement: HTMLElement,
  downloadName: string,
  callback?: () => void
) => {
  const dataUrl: string = await toPng(blobElement, {
    cacheBust: true
  });

  console.log(dataUrl);

  const link = document.createElement('a');
  link.href = dataUrl;
  link.download = downloadName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(dataUrl);
  callback?.();
};

export const generateSendTitleBySelectedMetrics = (
  selectedMetrics: Record<string, boolean>
): string => {
  const titleMap = {
    //============== 持仓深度诊断-总结 开始 ==============
    annualReturn: '年化收益率',
    sharpeRatio: '夏普比率',
    netValue: '账户净值表现',
    tradingFeatures: '交易特征',
    //============== 持仓深度诊断-总结 结束 ==============

    //============== 持仓深度诊断-持仓分析 开始 ==============
    holdingsStructure: '持仓结构',
    industryDistribution: '行业分布',
    holdingsConcentration: '持仓集中度',
    holdingsStyle: '持仓风格',
    //============== 持仓深度诊断-持仓分析 结束 ==============

    //============== 持仓深度诊断-交易行为 开始 ==============
    incomeEvaluations: '收益评估',
    tradingWinRate: '交易胜算',
    tradingDirection: '交易方向偏好',
    tradingFrequency: '交易频率分析',
    //============== 持仓深度诊断-交易行为 结束 ==============

    //============== 持仓深度诊断-优化推荐 开始 ==============
    portfolioAdjustment: '持仓结构调整建议',
    fundCombination: '推荐基金产品组合',
    cash: '现金管理',
    conservative: '稳健收益',
    aggressive: '进取收益',
    //============== 持仓深度诊断-优化推荐 结束 ==============

    //============== 投顾洞察-产品对比 开始 ==============
    basicInfo: '基础信息对比',
    performanceComparison: '收益表现对比',
    riskAssessmentComparison: '风险评估对比',
    positionAnalysis: '持仓穿透分析',
    //============== 投顾洞察-产品对比 结束 ==============

    //============== 投顾洞察-产品解读 开始 ==============
    // incomeEvaluations: '收益评估',
    advantage: '产品优势',
    risk: '风险提示',
    suggestion: '具体操作建议',
    //============== 投顾洞察-产品解读 结束 ==============

    //============== 投顾洞察-市场解读 开始 ==============
    policy_environment_analysis: '政策环境分析',
    industry_trend_analysis: '行业趋势分析',
    leading_enterprise_analysis: '龙头企业分析',
    investment_recommendations: '投资建议'
    //============== 投顾洞察-市场解读 结束 ==============
  };
  return Object.keys(selectedMetrics)
    .map(key => {
      return selectedMetrics[key] ? titleMap[key] : '';
    })
    .filter(Boolean)
    .join('、');
};

// 图表转图片的API接口
export const convertChartToImage = async (chartElement: HTMLElement): Promise<string> => {
  try {
    // 使用 html2canvas 将图表元素转换为图片
    // const canvas = await import('html2canvas').then(module => module.default);
    // const canvasElement = await canvas(chartElement, {
    //   backgroundColor: '#ffffff',
    //   scale: 2,
    //   useCORS: true,
    //   allowTaint: true
    // });

    // // 转换为 Blob
    // const blob = await new Promise<Blob>(resolve => {
    //   canvasElement.toBlob(blob => {
    //     resolve(blob as Blob);
    //   }, 'image/png');
    // });
   
    
    const blob = await toBlob(chartElement);
    if (!blob) {
      toast.error('转换图片失败：生成的blob为空');
      return '';
    }

    // 创建 FormData
    const formData = new FormData();
    formData.append('file', blob);
    formData.append('mediaType', '1');
    formData.append('corpId', WECOM_CORP_ID);

    // 调用后端接口
    const response = await convertChartToImageApi(formData);

    return response;
  } catch (error) {
    console.error('Failed to convert chart to image:', error);
    // 降级处理：返回一个模拟ID
    return 'mock-image-id-' + Date.now();
  }
};

// 格式化市场分析数据
export const formatMarketAnalysis = (data: string): string => {
  if (!data) return '';

  // 将长文本分段，每段不超过100字符
  const sentences = data.split(/[。！？]/).filter(s => s.trim());
  const paragraphs: string[] = [];
  let currentParagraph = '';

  sentences.forEach(sentence => {
    const trimmed = sentence.trim();
    if (currentParagraph.length + trimmed.length > 100) {
      if (currentParagraph) {
        paragraphs.push(currentParagraph + '。');
        currentParagraph = trimmed;
      } else {
        paragraphs.push(trimmed + '。');
      }
    } else {
      currentParagraph += (currentParagraph ? '' : '') + trimmed;
    }
  });

  if (currentParagraph) {
    paragraphs.push(currentParagraph + '。');
  }

  return paragraphs.join('\n\n');
};

// 格式化建议数据
export const formatSuggestion = (data: string): string => {
  if (!data) return '';

  // 按序号或项目符号分段
  const items = data.split(/\n|；|;|、/).filter(item => item.trim());
  return items.map((item, index) => `${index + 1}. ${item.trim()}`).join('\n');
};

// 格式化数值数据
export const formatNumericData = (label: string, value: number | string, unit?: string): string => {
  const formattedValue = typeof value === 'number' ? value.toFixed(2) : value;
  const unitStr = unit ? ` ${unit}` : '';
  return `${label}: ${formattedValue}${unitStr}`;
};

// 主要的数据格式化函数
export const formatSelectedData = async (config: FormatConfig): Promise<FormattedDataItem[]> => {
  const { tabType = 'overview' } = config;

  // 根据不同的 tab 类型调用不同的格式化函数
  switch (tabType) {
    // 持仓深度诊断 - 持仓分析
    case 'holdings':
      return await formatHoldingsData(config);
    // 持仓深度诊断 - 交易行为
    case 'trading':
      // TODO: 实现交易数据格式化
      return await formatTradingData(config);
    // 持仓深度诊断 - 优化推荐
    case 'recommendations':
      // TODO: 实现推荐数据格式化
      return await formatRecommendationsData(config);
    // 投顾洞察 - 市场解读
    case 'marketInterpretation':
      // TODO: 实现市场解读数据格式化
      return await formatMarketInterpretationData(config);
    // 投顾洞察 - 产品解读
    case 'productInterpretation':
      // TODO: 实现产品解读数据格式化
      return await formatProductInterpretationData(config);
    // 投顾洞察 - 产品对比
    case 'productComparison':
      // TODO: 实现产品对比数据格式化
      return await formatProductComparisonData(config);
    // 持仓深度诊断 - 总览
    case 'overview':
    default:
      return await formatOverviewData(config);
  }
};

// 格式化概览数据
export const formatOverviewData = async (config: FormatConfig): Promise<FormattedDataItem[]> => {
  const { selectedMetrics, totalData } = config;
  const formattedItems: FormattedDataItem[] = [];

  const customerInfoDetail =
    totalData.customerInfo.length > 0 ? totalData.customerInfo[0] : ({} as CopilotValue2Detail);
  const max_profit_take = new Decimal(customerInfoDetail.max_profit_take || 0).times(100);
  const sharpe_ratio = new Decimal(customerInfoDetail.sharpe_ratio || 0).times(100);
  const annualReturnObj = {
    max_profit_take: max_profit_take.toString(),
    max_profit_take_unit: max_profit_take.greaterThan(0) ? '+' : '-',
    sharpe_ratio: sharpe_ratio.toString(),
    sharpe_ratio_unit: sharpe_ratio.greaterThan(0) ? '+' : '-'
  };
  // 年化收益率
  if (selectedMetrics.annualReturn) {
    formattedItems.push({
      type: 'text',
      content: `年化收益率: ${annualReturnObj.max_profit_take_unit}${annualReturnObj.max_profit_take}%`,
      title: '年化收益率'
    });
  }

  // 夏普比率
  if (selectedMetrics.sharpeRatio) {
    formattedItems.push({
      type: 'text',
      content: `夏普比率: ${annualReturnObj.sharpe_ratio_unit}${annualReturnObj.sharpe_ratio}%`,
      title: '夏普比率'
    });
  }

  console.log('ldldldldldl');

  // 市场分析
  if (selectedMetrics.market_analysis && totalData.market_analysis) {
    formattedItems.push({
      type: 'text',
      content: formatMarketAnalysis(totalData.market_analysis),
      title: '市场分析'
    });
  }

  // 建议
  if (selectedMetrics.suggestion && totalData.suggestion) {
    formattedItems.push({
      type: 'text',
      content: formatSuggestion(totalData.suggestion),
      title: '投资建议'
    });
  }

  // 净值图表 - 需要转换为图片
  if (selectedMetrics.netValue) {
    const chartElement = document.querySelector('[data-chart="netValue"]') as HTMLElement;
    if (chartElement) {
      try {
        const imageId = await convertChartToImage(chartElement);
        formattedItems.push({
          type: 'image',
          content: `${config.timeRange}`,
          imageId,
          title: '账户净值表现'
        });
      } catch (error) {
        console.error('Failed to convert net value chart:', error);
        // 降级为文本描述
        formattedItems.push({
          type: 'text',
          content: `净值表现: 图片解析失败`,
          title: '净值表现'
        });
      }
    }
  }

  const currentTradingActivity = extractNumber(customerInfoDetail.trading_activity_rank || 0);

  if (selectedMetrics.tradingFeatures) {
    formattedItems.push({
      type: 'text',
      content: `月均交易次数: ${customerInfoDetail.monthly_avg_trades}\n年换手率: ${times100(
        customerInfoDetail.annualized_turnover_rate || 0
      ).toString()}%\n交易活跃度: 战胜${currentTradingActivity}%的股民`,
      title: '交易特征'
    });
  }

  return formattedItems;
};

// 将格式化后的数据转换为发送格式
export const formatDataForSending = (items: FormattedDataItem[]): string => {
  const sections = items.map(item => {
    const header = `【${item.title}】`;
    if (item.type === 'text') {
      return `${header}\n${item.content}`;
    } else {
      return `${header}\n${item.content} (图片ID: ${item.imageId})`;
    }
  });

  return sections.join('\n\n');
};

// 格式化持仓数据
export const formatHoldingsData = async (config: FormatConfig): Promise<FormattedDataItem[]> => {
  const { selectedMetrics, totalData } = config;
  const customerInfoDetail =
    totalData.customerInfo.length > 0 ? totalData.customerInfo[0] : ({} as CopilotValue2Detail);
  const formattedItems: FormattedDataItem[] = [];

  // 持仓总结
  if (selectedMetrics.holding_product_review && totalData.holding_product_review) {
    formattedItems.push({
      type: 'text',
      content: formatMarketAnalysis(totalData.holding_product_review),
      title: '持仓总结'
    });
  }

  // 资产配置
  if (
    selectedMetrics.cash_before ||
    selectedMetrics.stable_before ||
    selectedMetrics.aggressive_before
  ) {
    const assetAllocation = [];
    if (selectedMetrics.cash_before && totalData.cash_before) {
      assetAllocation.push(`现金类: ${totalData.cash_before}`);
    }
    if (selectedMetrics.stable_before && totalData.stable_before) {
      assetAllocation.push(`稳健类: ${totalData.stable_before}`);
    }
    if (selectedMetrics.aggressive_before && totalData.aggressive_before) {
      assetAllocation.push(`激进类: ${totalData.aggressive_before}`);
    }

    if (assetAllocation.length > 0) {
      formattedItems.push({
        type: 'text',
        content: assetAllocation.join('\n'),
        title: '资产配置'
      });
    }
  }

  // 基金持仓
  if (selectedMetrics.holding_fund_count || selectedMetrics.largest_holding_fund) {
    const fundInfo = [];
    if (selectedMetrics.holding_fund_count && totalData.holding_fund_count) {
      fundInfo.push(`持有基金数量: ${totalData.holding_fund_count}`);
    }
    if (selectedMetrics.largest_holding_fund && totalData.largest_holding_fund) {
      fundInfo.push(`最大持仓基金: ${totalData.largest_holding_fund}`);
    }

    if (fundInfo.length > 0) {
      formattedItems.push({
        type: 'text',
        content: fundInfo.join('\n'),
        title: '基金持仓'
      });
    }
  }

  // 行业分布
  if (
    selectedMetrics.holding_industry_count ||
    selectedMetrics.largest_industry_ratio ||
    selectedMetrics.top5_industry_ratio_details
  ) {
    const industryInfo = [];
    if (selectedMetrics.holding_industry_count && totalData.holding_industry_count) {
      industryInfo.push(`持有行业数量: ${totalData.holding_industry_count}`);
    }
    if (selectedMetrics.largest_industry_ratio && totalData.largest_industry_ratio) {
      industryInfo.push(`最大行业占比: ${totalData.largest_industry_ratio}`);
    }
    if (selectedMetrics.top5_industry_ratio_details && totalData.top5_industry_ratio_details) {
      industryInfo.push(
        `前5大行业详情:\n${formatSuggestion(totalData.top5_industry_ratio_details)}`
      );
    }

    if (industryInfo.length > 0) {
      formattedItems.push({
        type: 'text',
        content: industryInfo.join('\n'),
        title: '行业分布'
      });
    }
  }

  // 持仓集中度
  if (selectedMetrics.top5_holding_ratio || selectedMetrics.top10_holding_ratio) {
    const concentrationInfo = [];
    if (selectedMetrics.top5_holding_ratio && customerInfoDetail.top5_holding_ratio) {
      concentrationInfo.push(`前5大持仓占比: ${customerInfoDetail.top5_holding_ratio}`);
    }
    if (selectedMetrics.top10_holding_ratio && customerInfoDetail.top10_holding_ratio) {
      concentrationInfo.push(`前10大持仓占比: ${customerInfoDetail.top10_holding_ratio}`);
    }

    if (concentrationInfo.length > 0) {
      formattedItems.push({
        type: 'text',
        content: concentrationInfo.join('\n'),
        title: '持仓集中度'
      });
    }
  }

  // 持仓风格
  if (
    selectedMetrics.largest_holding_style ||
    selectedMetrics.excess_return_last_6months ||
    selectedMetrics.style_dimension
  ) {
    const styleInfo = [];
    if (selectedMetrics.largest_holding_style && totalData.largest_holding_style) {
      styleInfo.push(`主要持仓风格: ${totalData.largest_holding_style}`);
    }
    if (selectedMetrics.excess_return_last_6months && totalData.excess_return_last_6months) {
      styleInfo.push(`近6个月超额收益: ${totalData.excess_return_last_6months}`);
    }
    if (selectedMetrics.style_dimension && totalData.style_dimension) {
      styleInfo.push(`风格维度: ${totalData.style_dimension}`);
    }

    if (styleInfo.length > 0) {
      formattedItems.push({
        type: 'text',
        content: styleInfo.join('\n'),
        title: '持仓风格'
      });
    }
  }

  // 图表转换 - 持仓结构图表
  if (selectedMetrics.holdingsStructure) {
    const chartElement = document.querySelector('[data-chart="holdingsStructure"]') as HTMLElement;
    if (chartElement) {
      try {
        const imageId = await convertChartToImage(chartElement);
        formattedItems.push({
          type: 'image',
          content: '持仓结构图表',
          imageId,
          title: '持仓结构'
        });
      } catch (error) {
        console.error('Failed to convert holdings structure chart:', error);
        formattedItems.push({
          type: 'text',
          content: '持仓结构: 图片解析失败',
          title: '持仓结构'
        });
      }
    }
  }

  // 图表转换 - 行业分布图表
  if (selectedMetrics.industryDistribution) {
    const chartElement = document.querySelector(
      '[data-chart="industryDistribution"]'
    ) as HTMLElement;
    if (chartElement) {
      try {
        const imageId = await convertChartToImage(chartElement);
        formattedItems.push({
          type: 'image',
          content: '行业分布图表',
          imageId,
          title: '行业分布'
        });
      } catch (error) {
        console.error('Failed to convert industry distribution chart:', error);
        formattedItems.push({
          type: 'text',
          content: '行业分布: 图片解析失败',
          title: '行业分布'
        });
      }
    }
  }

  // 图表转换 - 持仓集中度图表
  if (selectedMetrics.holdingsConcentration) {
    formattedItems.push({
      type: 'text',
      content: `前5大持仓占比: ${times100(
        extractNumber(customerInfoDetail.top5_holding_ratio.toString())
      ).toString()}%\n前10大持仓占比: ${times100(
        extractNumber(customerInfoDetail.top10_holding_ratio.toString())
      ).toString()}%`,
      title: '持仓集中度'
    });
  }

  // 图表转换 - 持仓风格图表
  if (selectedMetrics.holdingsStyle) {
    try {
      formattedItems.push({
        type: 'text',
        content: `主要基金风格: 大盘成长 ${extractNumber(
          customerInfoDetail.largest_holding_style.toString()
        )}%\n近半年超额收益: ${
          times100(customerInfoDetail.excess_return_last_6months).greaterThan(0) ? '+' : '-'
        }${times100(customerInfoDetail.excess_return_last_6months).toString()}%\n风格维度: ${(
          customerInfoDetail.style_dimension || ''
        )
          .split('、')
          .map(item => `${item.split(' ')[0]} ${item.split(' ')[1]}`)
          .join('、')}`,
        title: '持仓风格'
      });
    } catch (error) {
      formattedItems.push({
        type: 'text',
        content: `主要基金风格: 解析出问题`,
        title: '持仓风格'
      });
    }
  }

  return formattedItems;
};

// 格式化交易数据
export const formatTradingData = async (config: FormatConfig): Promise<FormattedDataItem[]> => {
  const { selectedMetrics, totalData } = config;
  const customerInfoDetail =
    totalData.customerInfo.length > 0 ? totalData.customerInfo[0] : ({} as CopilotValue2Detail);
  const formattedItems: FormattedDataItem[] = [];

  // 图表转换 - 收益评估图表
  if (selectedMetrics.industryDistribution) {
    const chartElement = document.querySelector(
      '[data-chart="industryDistribution"]'
    ) as HTMLElement;
    if (chartElement) {
      try {
        const imageId = await convertChartToImage(chartElement);
        formattedItems.push({
          type: 'image',
          content: '收益评估图表',
          imageId,
          title: '收益评估'
        });
      } catch (error) {
        console.error('Failed to convert industry distribution chart:', error);
        formattedItems.push({
          type: 'text',
          content: '收益评估: 图片解析失败',
          title: '收益评估'
        });
      }
    }
  }

  // 图表转换 - 交易胜率图表
  if (selectedMetrics.tradingWinRate) {
    const chartElement = document.querySelector('[data-chart="tradingWinRate"]') as HTMLElement;
    if (chartElement) {
      try {
        const imageId = await convertChartToImage(chartElement);
        formattedItems.push({
          type: 'image',
          content: '交易胜率图表',
          imageId,
          title: '交易胜率'
        });
      } catch (error) {
        console.error('Failed to convert industry distribution chart:', error);
        formattedItems.push({
          type: 'text',
          content: '交易胜率: 图片解析失败',
          title: '交易胜率'
        });
      }
    }
  }

  // 图表转换 - 交易方向图表
  if (selectedMetrics.tradingDirection) {
    const chartElement = document.querySelector('[data-chart="tradingDirection"]') as HTMLElement;
    if (chartElement) {
      try {
        const imageId = await convertChartToImage(chartElement);
        formattedItems.push({
          type: 'image',
          content: '交易方向偏好图表',
          imageId,
          title: '交易方向偏好'
        });
      } catch (error) {
        console.error('Failed to convert industry distribution chart:', error);
        formattedItems.push({
          type: 'text',
          content: '交易方向偏好: 图片解析失败',
          title: '交易方向偏好'
        });
      }
    }
  }

  // 交易频率分析
  if (selectedMetrics.tradingFrequency) {
    try {
      formattedItems.push({
        type: 'text',
        content: `年化周转率: ${times100(
          customerInfoDetail.annual_turnover_rate
        ).toString()}%\n月均交易次数: ${extractNumber(
          customerInfoDetail.monthly_avg_trades
        )}次\n平均持仓周期: ${extractNumber(customerInfoDetail.avg_holding_period)}天`,
        title: '交易频率分析'
      });
    } catch (error) {
      formattedItems.push({
        type: 'text',
        content: '解析出问题',
        title: '交易频率分析'
      });
    }
  }
  return formattedItems;
};

// 格式化产品解读数据
export const formatProductInterpretationData = async (
  config: FormatConfig
): Promise<FormattedDataItem[]> => {
  const { selectedMetrics, totalData } = config;
  const formattedItems: FormattedDataItem[] = [];

  // 图表转换 - 收益与回撤概览
  if (selectedMetrics.incomeEvaluations) {
    const chartElement = document.querySelector('[data-chart="incomeEvaluations"]') as HTMLElement;
    if (chartElement) {
      try {
        const imageId = await convertChartToImage(chartElement);
        formattedItems.push({
          type: 'image',
          content: '收益与回撤概览',
          imageId,
          title: '收益与回撤概览'
        });
      } catch (error) {
        console.error('Failed to convert industry distribution chart:', error);
        formattedItems.push({
          type: 'text',
          content: '收益与回撤概览: 图片解析失败',
          title: '收益与回撤概览'
        });
      }
    }
  }

  // 产品优势
  if (selectedMetrics.advantage) {
    try {
      formattedItems.push({
        type: 'text',
        content: `${(totalData.产品优势 || '')
          .split(/\d+\.\s+/)
          .filter(item => item.trim())
          .map(item => `· ${item.trim()}`)
          .join('\n')}`,
        title: '产品优势'
      });
    } catch (error) {
      formattedItems.push({
        type: 'text',
        content: '解析出问题',
        title: '产品优势'
      });
    }
  }

  // 风险提示
  if (selectedMetrics.risk) {
    try {
      formattedItems.push({
        type: 'text',
        content: `${(totalData.风险提示 || '')
          .split(/\d+\.\s+/)
          .filter(item => item.trim())
          .map(item => `· ${item.trim()}`)
          .join('\n')}`,
        title: '风险提示'
      });
    } catch (error) {
      formattedItems.push({
        type: 'text',
        content: '解析出问题',
        title: '风险提示'
      });
    }
  }

  // 具体操作建议
  if (selectedMetrics.suggestion) {
    try {
      formattedItems.push({
        type: 'text',
        content: `${(totalData.操作建议 || []).map(item => `· ${item.trim()}`).join('\n')}`,
        title: '具体操作建议'
      });
    } catch (error) {
      formattedItems.push({
        type: 'text',
        content: '解析出问题',
        title: '具体操作建议'
      });
    }
  }

  return formattedItems;
};

// 格式化市场解读数据
export const formatMarketInterpretationData = async (
  config: FormatConfig
): Promise<FormattedDataItem[]> => {
  const { selectedMetrics, totalData } = config;
  const formattedItems: FormattedDataItem[] = [];
  // 政策环境分析
  if (selectedMetrics.policy_environment_analysis) {
    try {
      formattedItems.push({
        type: 'text',
        content: `${totalData.policy_environment_analysis}`,
        title: '政策环境分析'
      });
    } catch (error) {
      formattedItems.push({
        type: 'text',
        content: '解析出问题',
        title: '政策环境分析'
      });
    }
  }
  // 行业趋势分析
  if (selectedMetrics.industry_trend_analysis) {
    try {
      formattedItems.push({
        type: 'text',
        content: `${totalData.industry_trend_analysis}`,
        title: '行业趋势分析'
      });
    } catch (error) {
      formattedItems.push({
        type: 'text',
        content: '解析出问题',
        title: '行业趋势分析'
      });
    }
  }
  // 领先企业分析
  if (selectedMetrics.leading_enterprise_analysis) {
    try {
      formattedItems.push({
        type: 'text',
        content: `${totalData.leading_enterprise_analysis}`,
        title: '龙头企业分析'
      });
    } catch (error) {
      formattedItems.push({
        type: 'text',
        content: '解析出问题',
        title: '龙头企业分析'
      });
    }
  }
  // 投资建议
  if (selectedMetrics.investment_recommendations) {
    try {
      formattedItems.push({
        type: 'text',
        content: `${totalData.investment_recommendations}`,
        title: '投资建议'
      });
    } catch (error) {
      formattedItems.push({
        type: 'text',
        content: '解析出问题',
        title: '投资建议'
      });
    }
  }
  return formattedItems;
};

// 格式化推荐数据
export const formatRecommendationsData = async (
  config: FormatConfig
): Promise<FormattedDataItem[]> => {
  const { selectedMetrics, totalData } = config;
  const formattedItems: FormattedDataItem[] = [];
  // 交易频率分析
  if (selectedMetrics.portfolioAdjustment) {
    const {
      cash_beforeRatio,
      cash_afterRatio,
      // cash_trend,
      stable_beforeRatio,
      stable_afterRatio,
      // stable_trend,
      aggressive_beforeRatio,
      aggressive_afterRatio
      // aggressive_trend
    } = calculateAdjustment(totalData);
    try {
      formattedItems.push({
        type: 'text',
        content:
          `现金管理: ${cash_beforeRatio}% -> ${cash_afterRatio}%\n` +
          `稳健收益: ${stable_beforeRatio}% -> ${stable_afterRatio}%\n` +
          `进取收益: ${aggressive_beforeRatio}% -> ${aggressive_afterRatio}% \n` +
          `【优化后组合优势】\n` +
          `- ${totalData.advantage1_title}: ${totalData.advantage1_desc}\n` +
          `- ${totalData.advantage2_title}: ${totalData.advantage2_desc}\n` +
          `- ${totalData.advantage3_title}: ${totalData.advantage3_desc}`,
        title: '持仓结构调整建议'
      });
    } catch (error) {
      formattedItems.push({
        type: 'text',
        content: '解析出问题',
        title: '持仓结构调整建议'
      });
    }
  }

  // 图表转换 - 推荐基金产品组合图表
  if (selectedMetrics.fundCombination) {
    const chartElement = document.querySelector('[data-chart="fundCombination"]') as HTMLElement;
    if (chartElement) {
      try {
        const imageId = await convertChartToImage(chartElement);
        formattedItems.push({
          type: 'image',
          content: '推荐基金产品组合图表',
          imageId,
          title: '推荐基金产品组合'
        });
      } catch (error) {
        console.error('Failed to convert industry distribution chart:', error);
        formattedItems.push({
          type: 'text',
          content: '推荐基金产品组合: 图片解析失败',
          title: '推荐基金产品组合'
        });
      }
    }
  }

  const { fundData } = config;

  // 处理各类型基金产品卡片
  Object.entries(fundData).forEach(([key, data]: [string, any]) => {
    if (selectedMetrics[key]) {
      try {
        let fundContent = `建议配置比例：${data.suggestRatio}\n`;

        data.fundProducts.forEach((fund, index) => {
          fundContent += `\n基金 ${index + 1}：${fund.name}（代码：${fund.code}）\n`;
          fund.metrics.forEach(metric => {
            const value = `${metric.prefix || ''}${metric.value || 0}${metric.suffix || ''}`;
            fundContent += `- ${metric.label}：${value}\n`;
          });
        });

        console.log(fundContent, fundData, 'dlfundContentfundContentdld');

        formattedItems.push({
          type: 'text',
          content: fundContent,
          title: data.title
        });
      } catch (error) {
        formattedItems.push({
          type: 'text',
          content: '解析出问题',
          title: data.title || key
        });
      }
    }
  });
  return formattedItems;
};

// 格式化产品对比数据
export const formatProductComparisonData = async (
  config: FormatConfig
): Promise<FormattedDataItem[]> => {
  const { selectedMetrics, totalData } = config;
  const formattedItems: FormattedDataItem[] = [];
  // 基金产品深度 对比分析专业对比
  if (selectedMetrics.analysisSpec) {
    try {
      formattedItems.push({
        type: 'text',
        content: `${totalData.analysisSpec}`,
        title: '基金产品深度 对比分析专业对比'
      });
    } catch (error) {
      formattedItems.push({
        type: 'text',
        content: '解析出问题',
        title: '基金产品深度 对比分析专业对比'
      });
    }
  }
  // 基础信息对比
  if (selectedMetrics.basicInfo) {
    try {
      const productInfo = totalData?.product_info || [];
      const product1 = productInfo[0] || {};
      const product2 = productInfo[1] || {};

      // 添加产品名称信息
      let productInfoContent = '';
      productInfoContent += `产品1: ${product1.产品名称 || '未知'}\n`;
      productInfoContent += `产品2: ${product2.产品名称 || '未知'}\n\n`;

      formattedItems.push({
        type: 'text',
        content: productInfoContent,
        title: '产品信息'
      });

      const fields = [
        { key: '产品名称', label: '产品' },
        { key: '基金代码', label: '基金代码' },
        { key: '基金类型', label: '基金类型' },
        { key: '成立时间', label: '成立时间' },
        { key: '规模', label: '基金规模' },
        { key: '管理费率', label: '管理费率' },
        { key: '风险等级', label: '风险等级' },
        { key: '基金经理', label: '基金经理' },
        { key: '任职年限', label: '任职年限' },
        { key: '跟踪指数', label: '跟踪指数' }
      ];

      // 构建对比表格内容
      let tableContent = '【产品对比表格】\n\n';

      // 表头
      tableContent += '产品\t\t\t产品1\t\t\t产品2\n';
      tableContent += '─'.repeat(50) + '\n';

      // 数据行
      fields.slice(1).forEach(field => {
        const product1Value = product1[field.key] || '无';
        const product2Value = product2[field.key] || '无';
        tableContent += `${field.label}\t\t${product1Value}\t\t${product2Value}\n`;
      });

      // 添加投资策略总结
      tableContent += '\n【AI总结-投资策略】\n';
      tableContent += totalData?.投资策略 || '无';

      formattedItems.push({
        type: 'text',
        content: tableContent,
        title: '基础信息对比'
      });
    } catch (error) {
      formattedItems.push({
        type: 'text',
        content: '解析出问题',
        title: '基础信息对比'
      });
    }
  }
  // 收益表现对比
  if (selectedMetrics.performanceComparison) {
    const chartElement = document.querySelector(
      '[data-chart="performanceComparisonChart"]'
    ) as HTMLElement;
    if (chartElement) {
      try {
        const imageId = await convertChartToImage(chartElement);
        formattedItems.push({
          type: 'image',
          content: '收益表现对比图表',
          imageId,
          title: '收益表现对比'
        });
      } catch (error) {
        console.error('Failed to convert industry distribution chart:', error);
        formattedItems.push({
          type: 'text',
          content: '收益表现对比: 图片解析失败',
          title: '收益表现对比'
        });
      }
    }
    // try {
    //   // 模拟收益数据表格
    //   const performanceData = [
    //     { period: '近1周', product1: '+3.24%', product2: '+1.18%', difference: '+2.06%' },
    //     { period: '近1月', product1: '+5.67%', product2: '+2.34%', difference: '+3.33%' },
    //     { period: '近3月', product1: '+8.92%', product2: '+4.56%', difference: '+4.36%' },
    //     { period: '近1年', product1: '-12.45%', product2: '-8.23%', difference: '-4.22%' },
    //     { period: '成立以来', product1: '+15.67%', product2: '+12.34%', difference: '+3.33%' }
    //   ];

    //   // 构建表格内容
    //   let tableContent = '';

    //   // 表头
    //   tableContent += '时间段\t\t\t产品1\t\t\t产品2\t\t\t差值\n';
    //   tableContent += '─'.repeat(60) + '\n';

    //   // 数据行
    //   performanceData.forEach(item => {
    //     // const product1Name = product1.产品名称 || '产品1';
    //     // const product2Name = product2.产品名称 || '产品2';
    //     tableContent += `${item.period}\t\t${item.product1}\t\t${item.product2}\t\t${item.difference}\n`;
    //   });

    //   // 添加AI总结
    //   if (totalData.performanceComparison) {
    //     tableContent += '\n【AI总结-历史业绩】\n';
    //     tableContent += totalData.历史业绩;
    //   }

    //   formattedItems.push({
    //     type: 'text',
    //     content: tableContent,
    //     title: '收益表现对比表格'
    //   });
    // } catch (error) {
    //   formattedItems.push({
    //     type: 'text',
    //     content: '解析出问题',
    //     title: '收益表现对比'
    //   });
    // }
  }
  // 风险评估对比
  if (selectedMetrics.riskAssessmentComparison) {
    try {
      const productInfo = totalData?.product_info || [];
      const product1Data = productInfo[0] || {};
      const product2Data = productInfo[1] || {};

      // 构建风险评估对比表格
      let riskTableContent = '';

      // 表头
      riskTableContent += '产品\t\t\t产品1\t\t\t产品2\n';
      riskTableContent += '─'.repeat(50) + '\n';

      // 风险指标数据
      const riskMetrics = [
        { label: '年化波动率', product1: '+28.5%', product2: '+18.7%' },
        { label: '最大回撤', product1: '-32.8%', product2: '-24.6%' },
        { label: '夏普比率', product1: '0.42', product2: '0.78' },
        { label: '贝塔系数', product1: '1.25', product2: '0.92' }
      ];

      // 添加产品名称
      riskTableContent += `产品名称\t\t${product1Data.产品名称 || '产品1'}\t\t${
        product2Data.产品名称 || '产品2'
      }\n`;

      // 添加风险指标
      riskMetrics.forEach(metric => {
        riskTableContent += `${metric.label}\t\t${metric.product1}\t\t${metric.product2}\n`;
      });

      formattedItems.push({
        type: 'text',
        content: riskTableContent,
        title: '风险评估对比表格'
      });

      // 风险收益象限图
      const chartElement = document.querySelector(
        '[data-chart="riskAssessmentComparisonChart"]'
      ) as HTMLElement;
      if (chartElement) {
        try {
          const imageId = await convertChartToImage(chartElement);
          formattedItems.push({
            type: 'image',
            content: '风险收益象限图',
            imageId,
            title: '风险收益象限图'
          });
        } catch (error) {
          formattedItems.push({
            type: 'text',
            content: '风险收益象限图: 图片解析失败',
            title: '风险收益象限图'
          });
        }
      }

      formattedItems.push({
        type: 'text',
        content: totalData.风险评估对比 || '暂无内容',
        title: 'AI总结-风险收益'
      });
    } catch (error) {
      formattedItems.push({
        type: 'text',
        content: '解析出问题',
        title: '风险评估对比'
      });
    }
  }
  // 持仓穿透分析
  if (selectedMetrics.positionAnalysis) {
    try {
      const chartElement = document.querySelector(
        '[data-chart="positionAnalysisChart"]'
      ) as HTMLElement;
      if (chartElement) {
        try {
          const imageId = await convertChartToImage(chartElement);
          formattedItems.push({
            type: 'image',
            content: '持仓穿透分析图',
            imageId,
            title: '持仓穿透分析图'
          });
        } catch (error) {
          formattedItems.push({
            type: 'text',
            content: '持仓穿透分析图: 图片解析失败',
            title: '持仓穿透分析'
          });
        }
      }

      formattedItems.push({
        type: 'text',
        content: totalData.持仓分析 || '暂无内容',
        title: 'AI总结-持仓分析'
      });
    } catch (error) {
      formattedItems.push({
        type: 'text',
        content: '解析出问题',
        title: '持仓穿透分析'
      });
    }
  }
  return formattedItems;
};
